import { colors } from '@constants/colors';
import { ScreenSizes } from '@interfaces';
import { useTheme } from '@mui/material';

export const useStyles = () => {
  const { breakpoints } = useTheme();

  return {
    warning: {
      display: 'flex',
      alignItems: 'center',
      gap: 1,
      mt: 4.5,
    },
    warningText: {
      color: colors.grey_third,
      fontSize: 12,
      lineHeight: 1.5,
      letterSpacing: '0.01em',
    },
    media: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      '& video': {
        objectFit: 'cover',
        maxWidth: 'unset !important',
        width: '100% !important',
        height: '100% !important',
        display: 'flex',
      },
      '& img': {
        objectFit: 'cover',
        maxWidth: 'unset !important',
        width: '100% !important',
        height: '100% !important',
        display: 'flex',
      },
    },
    progressWrap: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      marginTop: 4,
    },
    progressTextWrap: {
      background: '#F7F7F7',
      borderRadius: 2,
      px: 6,
      py: 1.5,
      maxWidth: 300,
      marginLeft: '-30px',

      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        py: 0.75,
        paddingLeft: 3.5,
        paddingRight: 1,
        marginLeft: '-20px',
        maxWidth: 260,
      },
    },
    progressText: {
      color: '#444444',
      fontSize: 16,

      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        fontSize: 14,
      },
    },
    progressWrapCircle: {
      background: colors.white,
      borderRadius: '50%',
      zIndex: 1,
      display: 'flex',

      '& > div': {
        marginTop: 0,
      },
    },
    timer: {
      color: '#444444',
      fontSize: 16,
      fontWeight: 700,

      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        fontSize: 14,
      },
    },
  };
};
